import FieldComponent from 'Pages/GMS/ISR/Components/FieldComponent';
import MultiChoiceConfigurations from 'Pages/GMS/ISR/Components/MultiChoiceConfigurationNew';
import RulesComponent from 'Pages/GMS/ISR/Components/Rules/RulesComponent';
import React, { useContext, useEffect, useState } from 'react';
import { TConnector, TField, TFieldDataConfiguration, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import { AppContext } from 'Context/AppContext';
import { getAllAttributes, getCategoryTypeAndCategory } from '../ModelServices/ModalServices';
import useFieldDataConfigurationUpdater from '../Hooks/useFieldDataConfigurationUpdater';
import AdditionalData from 'Pages/GMS/ISR/Components/AdditionalData';
import { getList } from 'Pages/GMS/List/Services/ListServices';

type MultiChoiceFieldProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    indexInfo: TIndexState;
    createISRProject:()=>void;
}

const MultiChoiceField = ({id, selectedItem, userProjectDataModels, setUserProjectDataModels, indexInfo, createISRProject}: MultiChoiceFieldProps) => {
    let appContext = useContext(AppContext);
    let industryId = appContext.get_selected_industry() && appContext?.get_selected_industry()?.id;
    const [attributeData, setAttributeData] = useState([]);
    const [listData, setListData] = useState([]);
    const [categoryTypeList, setCategoryTypeList] = useState<string[]>([]);
    const [categoryData, setCategoryData] = useState([]);

    const { updateFieldConfiguration } = useFieldDataConfigurationUpdater({ setUserProjectDataModels });

    const updateFieldDataConfiguration = (updatedConfig: TFieldDataConfiguration) => {
        updateFieldConfiguration(indexInfo, updatedConfig, (selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel) ?? false);
    };

    useEffect(() => {
        const fetchCategoryTypesAndCategories = async () => {
            try {
                setCategoryData([]);
                const attributeResponse = await getAllAttributes(industryId ?? '');
                if (attributeResponse?.done) {
                    const categoryTypes = attributeResponse?.data?.map((item: any) => {return{'name':item?.name,'id':item?.id}});
                    setAttributeData(categoryTypes);
                }
                const listResponse = await getList(industryId ?? '')
                if (!listResponse?.errorfound) {
                    // const lists = listResponse?.data?.map((item: any) => {return{'label':item?.name,'value':item?.id}});
                    setListData(listResponse?.data?.data);
                }
                const categoryResponse = await getCategoryTypeAndCategory(industryId ?? '');
                if (categoryResponse?.done) {
                    const categoryTypes = categoryResponse?.data?.map((item: any) => item?.name);
                    const filteredTypes: string[] = categoryTypes.filter((type: string) => type === 'Attribute Categories')
                    // const dataModelToUpdate = userProjectDataModels.project.dataModels[indexInfo.dataModelIndex ?? -1];
                    // const subModelCategories = dataModelToUpdate.data.productCategories.map((e) => e.data.categories.data.map((category) => category.id)).flat(1);
                    // let categoryTypesToDisplay = [];
                    // if(subModelCategories.length > 0) {
                    //     categoryTypesToDisplay = categoryResponse?.data?.map((item: any) => {
                    //         item.category = item.category.filter((e: any) => subModelCategories.includes(e.id))
                    //         return item;
                    //     }).filter((e: any) => e.category.length > 0);
                    // }
                    // setCategoryData(categoryTypesToDisplay);
                    setCategoryData(categoryResponse?.data);
                    setCategoryTypeList(filteredTypes);
                }
            } catch (e) {
                console.log('Error', e); 
            }
        }
        fetchCategoryTypesAndCategories();
    }, [indexInfo]);

    return (
        <div id={id}>
            <FieldComponent 
                id={`${id}-field`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br />
            <MultiChoiceConfigurations 
                id={`${id}-multi-choice-config`}
                attributeData={attributeData}
                categoryTypeList={categoryTypeList} 
                categoryData={categoryData} 
                listData={listData} 
                selectedItem={selectedItem} 
                updateFieldDataConfiguration={updateFieldDataConfiguration} 
                projectId={userProjectDataModels?.project?.id ?? ''} 
                userProjectDataModels={userProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br />
            <AdditionalData 
                id={`${id}-additional-data`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br/>
            <RulesComponent 
                id={`${id}-rules`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo} 
                createISRProject={createISRProject} 
                featureType="Field"
            />
        </div>
    );
}

export default MultiChoiceField;
